export default __webpack_public_path__ + "static/media/problem-finding-img1.5f5877b0.png";